<template>
    <div class="popup popup-setout panel-left-setout panel-left-comm cruise_search cruise-search-popup" 
    :class="{in: isShow}"
    id="panel-left-setout" data-type="row">
            <div class="popup-head">
                <a @click="goBack()" class="js-returnDetailBtn">
                    <img src="https://resource.rcclchina.com.cn/homePage/mobile/leftalllow.png" alt="">
                </a>
                选择出发港
            </div>
            <div  class="dest-area search-form-container" data-key="DepartureCode">
                <div class="area-select dest-sec" v-if="departureGroups.length > 1">
                    <div v-for="(group, i) in departureGroups" :key="i" 
                     :class="{active: currentGroupIndex == i}" data-area=""
                     @click="onChangeGroupClick(i)">
                        <div class="area-select-line"></div>
                        <div class="area-select-name">
                            {{group}}
                        </div>
                    </div>
                </div>
                <div class="area-country-select select-sec js-smartScroll">
                    <div v-for="(departureGroup, i) in departureGroups" :key="i" class="area-country" 
                    :class="{active: currentGroupIndex == i}" data-area="">
                        <ul class="country" :class="{'country-large' : departureGroups.length == 1}">
                            <li class="departure-area-item search-form-list-item" v-if="getDepartureByGroup(departureGroup).length > 1"
                                data-cnvalue="全部" data-filtercode="全部" 
                                data-key="DepartureCode" data-cruise="row"
                                :class="{ active: isSelectedAll(departureGroup), disable: isDisableAll(departureGroup) }"
                                @click="onDepartureAllClick(departureGroup)">
                                <img class="selected" src="https://resource.rcclchina.com.cn/homePage/mobile/mb-gou.png" alt="" />
                                <span>全部</span>
                            </li>
                            <li class="departure-area-item search-form-list-item"
                            v-for="(departure, index) in getDepartureByGroup(departureGroup)" :key="index"
                            :data-cnvalue="getDepartureTitle(departure.title)" 
                            :data-filtercode="departure.filterCode"
                            :class="{ active: isSelected(departure.filterCode), disable: isDisable(departure.filterCode)}"
                            @click="onDepartureClick(departure)"
                                >
                                <img class="selected" src="https://resource.rcclchina.com.cn/homePage/mobile/mb-gou.png" alt="" />
                                <span>{{getDepartureTitle(departure.title)}}</span>
                                <img class="flag" :src="departure.countryFlag" :style="getCountryFlagStyle(departure.filterCode)">
                                
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="click-btn">
                    <a class="reset-btn" @click="onClearClick()"> <img src="https://resource.rcclchina.com.cn/homePage/mobile/mb-reset.png" /> 重置</a>
                    <a class="define-btn" @click="goBack()"> <img src="https://resource.rcclchina.com.cn/homePage/mobile/mb-define.png"  /> 确定</a>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    name: 'DepartureForm',
    props: {
        cruiseType: {
            type: String,
            default: function() {
                return "hp"
            }
        },
        isShow: {
            type: Boolean,
            default: function() {
                return false
            }
        },
        departures: {
            type: Array,
            default: function() {
                return []
            }
        },
        departureGroups: {
            type: Array,
            default: function() {
                return []
            }
        },
        closeForm: {
            type: Function
        }
    },
    data () {
        return {
            selectDepartures: [],
            selectAllDepartureGroups: [],
            currentGroupIndex: 0
        }
    },
    methods: {
        goBack() {
            this.closeForm()
        },
        departureListStyle (index) {
            return (this.departureGroups.length > 1 && index == 0) ? { 'margin-left': '20px'} : {}
        },
        getDepartureByGroup (departureGroup) {
            return this.departures.filter(item => item.cruiseFilterGroupName == departureGroup)
        },
        getDepartureTitle (departureTitle) {
            return departureTitle.split('(')[0]
        },
        onDepartureClick (departure) {
            let code = departure.filterCode
            if (this.isDisable(code)) {
                return
            }
            let name = this.getDepartureTitle(departure.title)
            let group = departure.cruiseFilterGroupName
            let isExists = this.selectDepartures.some(item=> item.code == code)
            const cruiseType = this.cruiseType
            const data = { 
                cruiseType,
                key: 'departures',
                values: [{ code, name }]
            }
            if (isExists) {
                this.selectDepartures = this.selectDepartures.filter(item => !(item.code == code))
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)

                if (this.isSelectedAll(group)) {
                    this.selectAllDepartureGroups = this.selectAllDepartureGroups.filter(item=>!(item == group))
                }

            } else {
                this.selectDepartures.push({ code, name, group })
                this.$store.dispatch('SET_CRUISE_FILTERS', data)

                // 全选逻辑
                if (this.checkDepartureAllSelected(group)) {
                    if (!this.isSelectedAll(group)) {
                        this.selectAllDepartureGroups.push(group)
                    }
                }
            }
        },
        onDepartureAllClick (departureGroup) {
            const cruiseType = this.cruiseType
            // 反选
            if (this.isSelectedAll(departureGroup)) {
                this.selectAllDepartureGroups = this.selectAllDepartureGroups.filter(item=>!(item == departureGroup))
                // 删除该group下所有选择
                const needRemoveDeps = this.selectDepartures.filter(item => item.group == departureGroup)
                this.selectDepartures = this.selectDepartures.filter(item => !(item.group == departureGroup))
                const data = {
                    cruiseType,
                    key: 'departures',
                    values: needRemoveDeps
                }
                this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            } else {
                if (this.isDisableAll(departureGroup)) {
                    return
                }
                const departures = this.departures.filter(item=>item.cruiseFilterGroupName == departureGroup)
                let needAddDeps = []
                departures.forEach((departure) => {
                    if (!this.selectDepartures.some(item => item.code == departure.filterCode)) {
                        let code = departure.filterCode
                        if (!this.isDisable(code)) {
                            let name = this.getDepartureTitle(departure.title)
                            let group = departure.cruiseFilterGroupName
                            needAddDeps.push({ code, name, group })
                            this.selectDepartures.push({ code, name, group })
                        }
                    }
                })
                this.selectAllDepartureGroups.push(departureGroup)
                const data = {
                    cruiseType,
                    key: 'departures',
                    values: needAddDeps
                }
                this.$store.dispatch('SET_CRUISE_FILTERS', data)
            }
        },
        checkDepartureAllSelected (departureGroup) {
            let departures = this.getDepartureByGroup(departureGroup)
            let selectedCount = this.selectDepartures.filter(item => item.group == departureGroup).length
            return departures.length == selectedCount
        },
        isSelected (code) {
            return this.selectDepartures.some(item=> item.code == code)
        },
        isSelectedAll (departureGroup) {
            return this.selectAllDepartureGroups.includes(departureGroup)
        },
        onChangeGroupClick (index) {
            this.currentGroupIndex = index
        },
        onClearClick () {
            const data = {
                cruiseType: this.cruiseType,
                key: 'departures',
                values: this.selectDepartures
            }
            this.$store.dispatch('REMOVE_CRUISE_FILTERS', data)
            this.selectDepartures = []
            this.selectAllDepartureGroups = []
        },
        isDisable (code) {
            const availableItems = this.$store.state.cruise.filterResponse[this.cruiseType].departures
            return !availableItems.includes(code)
        },
        isDisableAll (departureGroup) {
            const availableItems = this.$store.state.cruise.filterResponse[this.cruiseType].departures
            let departureCodes = this.getDepartureByGroup(departureGroup).map(item=>item.filterCode)
            return !availableItems.some(item=> departureCodes.includes(item))
        },
        getCountryFlagStyle (filterCode) {
            if (filterCode == "LAB" || filterCode == "PCC")
            {
                return { "width": "16px" }
            }
            else if (filterCode == "")
            {
                return { "width": "18px" }
            }
            return {}
        }
    },
    computed: {
        filterResponseDepartures () {
            return this.$store.state.cruise.filterResponse[this.cruiseType].departures
        }
    },
    watch: {
        filterResponseDepartures (newOne) {
            if (this.departureGroups.length > 1) {
                // 查找第一个可以选择的sub category
                let availableIndexs = []
                const availableItems = newOne
                this.departureGroups.forEach((group, i) => {
                    const codes = this.getDepartureByGroup(group).map(item=>item.filterCode)
                    let isNotDisbaleAll = availableItems.some(item=> codes.includes(item))
                    if (isNotDisbaleAll) {
                        availableIndexs.push(i)
                    }
                })

                if (availableIndexs.length > 0 && !availableIndexs.includes(this.currentGroupIndex)) {
                    this.currentGroupIndex = availableIndexs[0]
                }
            } 
            

        }
    }
}
</script>